<template>
  <textarea class="editor-input" @input="onInput" v-html="value" ref="input"></textarea>

</template>

<script>

import MixinCKEditor from './mixin-ckeditor'
export default {
  mixins: [MixinCKEditor],
  props: {
    value: String
  },
  methods: {
    onInput () {
      this.$emit('input')
    }
  }
}
</script>

<style>
.webpage-content-editor .ck.ck-editor {
  min-height: 400px;
}
.webpage-content-editor .ck-editor__editable {
    min-height: 400px !important;
}
</style>
